import styled, { css } from 'styled-components'

export interface ToggleSwitchStyledProps {
  $checked?: boolean
  $size?: 'small' | 'medium' | 'large'
  $disabled?: boolean
}

const sizeStyles = {
  small: css`
    width: 36px;
    height: 20px;
    border-radius: 10px;

    &::after {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      top: 2px;
      left: 2px;
    }
  `,
  medium: css`
    width: 44px;
    height: 26px;
    border-radius: 13px;

    &::after {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      top: 3px;
      left: 3px;
    }
  `,
  large: css`
    width: 52px;
    height: 32px;
    border-radius: 16px;

    &::after {
      width: 26px;
      height: 26px;
      border-radius: 13px;
      top: 3px;
      left: 3px;
    }
  `,
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<ToggleSwitchStyledProps>`
  background: ${({ $checked, theme }) =>
    $checked ? theme.colors.primary : theme.colors.background.tertiary};
  border: 1px solid
    ${({ $checked, theme }) =>
      $checked ? theme.colors.primary : theme.colors.border.default};
  position: relative;
  transition: all 0.3s ease;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  ${({ $size = 'medium' }) => sizeStyles[$size]}

  &::after {
    content: '';
    position: absolute;
    background: ${({ theme }) => theme.colors.background.primary};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  ${({ $checked, $size = 'medium' }) =>
    $checked &&
    css`
      &::after {
        transform: translateX(
          ${$size === 'small' ? '16px' : $size === 'medium' ? '18px' : '20px'}
        );
      }
    `}
`

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: inherit;
`
